// @flow
import React from 'react';
import analytics from '../../../../../analytics';
import environment from '../../../../../environment';
import { endpoints, postPaymentExecuteApi } from '../../api';
import { catchError, map } from 'rxjs/operators';

import qempo from '../../../../../assets/img/logoq-primary.png'

import type { RootState } from '../../../../index';
import type { BillingAddressReq, PaymentExecuteReq } from '../../api';
import type { ImplementationType, PaymentImpl } from '../index';
import type { Order } from '../../../../../entities';
import type { Node } from 'react';

export default class NiubizWebPayment implements PaymentImpl {
  type: ImplementationType = 'niubiz_web';
  order: Order;
  // Niubiz specific properties
  domainCountry: string;

  setUpPayment(order: Order, dispatch: Function, rootState: RootState) {
    this.order = order;
    
    this.domainCountry = rootState.locale.domainCountry || 'PE';
    if (window) {
      const fullApiUrl = `${environment.baseUrl[this.domainCountry]}${environment.apiUrl}`;
      const actionUrl =
        `${fullApiUrl}/checkout/payment/${this.order.invoice.payment.id}/niubiz-web?order_id=${this.order.id}`;
      const options = {
        sessiontoken: this.order.invoice.payment.paymentData.sessionKey,
        channel: 'web',
        merchantid: environment.niubizMerchanId,
        purchasenumber: parseInt(this.order.id.substr(4)),
        merchantlogo: `${environment.baseUrl[this.domainCountry]}${qempo}`,
        formbuttoncolor: "#2196F3",
        amount: this.order.invoice.payment.total,
        expirationminutes: 5,
        timeouturl: window ? window.location.href : "",
        action: actionUrl,
      };
      console.log(options);
      console.log(JSON.stringify(options))
      window.VisanetCheckout.configure(options);
    }
  }

  generateCustomUI = (): ?Node => undefined;

  executeUIAction(billingAddress: BillingAddressReq, rootState: RootState) {
    const order = rootState.newOrder.checkoutStep.order;
    
    analytics.fireCustomEvent('Checkout Step Completed', {
      category: 'Checkout Step',
      action: 'Completed',
      label: order.id,
      user_type: 'purchaser',
      user_referrer: window.localStorage.getItem('userReferrer') || '',
      landing_url: window.localStorage.getItem('landingUrl') || '',
      order_id: order.id,
      order_formatted_id: order.id,
      payment_method: order.invoice && order.invoice.payment ? '' : order.invoice.payment.method,
      payment_sub_method: order.invoice && order.invoice.payment ? '' : order.invoice.payment.subtype,
      domain_country: this.domainCountry,
      type: 'sync',
      step: 1,
      shipping_method: order.serviceTier,
    });

    const paymentRequest: PaymentExecuteReq = {
      method: order.invoice.payment.method,
      type: order.invoice.payment.subtype,
      billingAddress: billingAddress,
    }
    
    postPaymentExecuteApi(paymentRequest, {
      route: endpoints.POST_PAYMENT_EXECUTE.replace(':paymentId', order.invoice.payment.id),
    }).toPromise().then(
      (order: Order) => {
        if (['AVAILABLE', 'AVAILABLE_FOR_COURIER'].includes(order.state)) {
          window.location.reload();
        }
      },
    ).catch(
      ({data}: {data: {message: string, name: string}}) => {
        console.log('Unsuccessful payment execution for Niubiz!', error);
        if (data.name === 'InvalidStateError') {
          document.location.reload();
        }
      },
    )
    if (window && window.VisanetCheckout) window.VisanetCheckout.open();
  }

  showPopUp = (data: string) => undefined;

  clean = () => undefined;
}



// WEBPACK FOOTER //
// ./src/modules/new-order/CheckoutStep/PaymentImpl/NiubizWeb/index.js